import { render, staticRenderFns } from "./StatsLastReviewsPictureModal.vue?vue&type=template&id=648586ab&"
import script from "./StatsLastReviewsPictureModal.vue?vue&type=script&lang=js&"
export * from "./StatsLastReviewsPictureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports